export default {
  common: {
    pleaseEnterSearchKeywords: "Por favor, introduzca palabras clave de búsqueda"
  },
  outputProjectList: {
    dateofRegistration: "Fecha de registro",
    updateDate: "hora de actualización",
    projectName: "Nombre del proyecto",
    dateofAudit: "Fecha de auditoría (año-mes)",
    customerName: "Nombre del cliente",
    customerEmail: "Correo electrónico del cliente",
    address: "Dirección",
    zone: "Zona",
    city: "Ciudad",
    submiter: "Enviador",
    projectStatus: "Estado del proyecto",
    estimateEcmQutedAmount: "Cantidad estimada de ECM cotizada (USD)",
    expectedOrder: "Orden esperada (mes/año)",
    actualEcmQutedAmount: "Cantidad real de ECM cotizada (USD)",
    actualOrder: "Orden real (mes/año)",
    winProbability: "Probabilidad de ganar",
    statusRemarks: "comentarios",
    lastUpdateDate: "Última fecha de actualización"
  },
  outputAccountList: {
    activate: "Activar",
    registerDate: "Fecha de registro",
    lastLoginDate: "Última fecha de inicio de sesión"
  },
  nomenclature: {
    row0_1: "Término",
    row0_2: "Definición",
    row1_1: "AC",
    row1_2: "Abreviatura de Air-cooled; significa refrigerado por aire.",
    row2_1: "AHRI",
    row2_2:
      "Abreviatura de Air-Conditioning, Heating, and Refrigeration Institute; organización sectorial de EE. UU. que certifica las clasificaciones de rendimiento de las enfriadoras utilizadas en las selecciones de eCAT.",
    row3_1: "Enfriadora refrigerada por aire",
    row3_2: "Enfriadora que rechaza el calor directamente al aire ambiente mediante ventiladores del condensador y no requiere torres de refrigeración ni bombas de agua del condensador.",
    row4_1: "Temperatura de aproximación",
    row4_2:
      "Diferencia de temperatura entre la temperatura del agua de salida de la torre de refrigeración y la temperatura de bulbo húmedo de entrada; valor predeterminado de 3 °C en iECM y parámetro clave para el modelado del agua de condensación.",
    row5_1: "ASIA",
    row5_2: "Cartera regional de Asia. Cartera de fabricación utilizada para enfriadoras Carrier principalmente lanzadas en Asia.",
    row6_1: "Línea base",
    row6_2: "Sistema actual de enfriadoras utilizado como referencia de comparación.",
    row7_1: "Tipo de edificio",
    row7_2: "Clasificación del tipo de edificio seleccionada durante la configuración del proyecto, como oficina, hotel, hospital u otros; puede influir en las hipótesis predeterminadas.",
    row8_1: "CAPEX",
    row8_2: "Abreviatura de Capital expenditure; se refiere a la inversión inicial del proyecto de retrofit.",
    row9_1: "Intensidad de carbono de la electricidad",
    row9_2:
      "Masa de CO₂ equivalente emitida por unidad de electricidad consumida; el valor predeterminado en iECM es 0.707 kgCO₂e/kWh, aunque varía según la región y la combinación energética de la red.",
    row10_1: "Enfriadora centrífuga",
    row10_2: 'Tipo de enfriadora que utiliza un compresor centrífugo y se emplea habitualmente en aplicaciones comerciales e industriales de gran tamaño; en iECM se referencia como "WC–Centri".',
    row11_1: "Agua helada",
    row11_2: "Agua enfriada por la enfriadora y distribuida por el sistema de climatización del edificio para proporcionar refrigeración a los espacios.",
    row12_1: "CHW",
    row12_2: "Abreviatura de Chilled water; significa agua helada.",
    row13_1: "CHWP",
    row13_2: "Abreviatura de Chilled water pump; significa bomba de agua helada.",
    row14_1: "Cluster",
    row14_2: "Grupo de meses con condiciones de funcionamiento o meteorológicas similares utilizado en la simulación.",
    row15_1: "Refrigeración de confort",
    row15_2: "Refrigeración proporcionada para el confort térmico de los ocupantes en edificios, como oficinas y hoteles; se distingue de la refrigeración de proceso.",
    row16_1: "Colector común",
    row16_2:
      "Configuración de tuberías de agua de condensación en la que todas las enfriadoras comparten un único colector de ida y retorno, lo que permite que cualquier torre de refrigeración atienda a cualquier enfriadora.",
    row17_1: "Agua de condensación",
    row17_2: "Agua que circula entre el condensador de la enfriadora y la torre de refrigeración para rechazar el calor del ciclo frigorífico.",
    row18_1: "COP",
    row18_2: "Abreviatura de Coefficient of Performance; significa coeficiente de rendimiento.",
    row19_1: "CT",
    row19_2: "Abreviatura de Cooling tower; significa torre de refrigeración.",
    row20_1: "CWP",
    row20_2: "Abreviatura de Condenser water pump; significa bomba de agua de condensación.",
    row21_1: "CWS",
    row21_2: "Abreviatura de Condenser water supply; significa impulsión de agua de condensación.",
    row22_1: "DB",
    row22_2: "Abreviatura de Electrical distribution board; significa cuadro de distribución eléctrica.",
    row23_1: "Tasa de degradación",
    row23_2:
      "Disminución porcentual anual de la eficiencia de la enfriadora debida al envejecimiento, la suciedad y el desgaste; las hipótesis típicas son 0.25 % para Bueno, 0.50 % para Medio, 0.75 % para Inferior a la media y 1.00 % para Malo.",
    row24_1: "Digital e-CAT",
    row24_2: "Herramienta de modelado basada en la física y en datos que predice el rendimiento de las enfriadoras.",
    row25_1: "Tasa de descuento",
    row25_2: "Tipo de interés utilizado para calcular el valor actual de los flujos de caja futuros en el análisis NPV; el valor predeterminado en iECM es 3 %.",
    row26_1: "Temperatura de bulbo seco",
    row26_2:
      "Temperatura del aire ambiente medida con un termómetro estándar, no afectada por la humedad; se utiliza en iECM en perfiles meteorológicos para el modelado de enfriadoras refrigeradas por aire y la configuración de clusters.",
    row27_1: "Biblioteca e-CAT",
    row27_2: "Base de datos oficial de enfriadoras Carrier e-CAT disponible para todos los usuarios.",
    row28_1: "EA",
    row28_2: "Abreviatura de Energy audit; significa auditoría energética.",
    row29_1: "EA Report",
    row29_2: "Energy Audit Report; informe de baseline generado al final del paso de vista previa de la baseline, que documenta el rendimiento actual del sistema y las oportunidades de mejora.",
    row30_1: "eCAT",
    row30_2: "Catálogo electrónico de Carrier y software de selección de enfriadoras.",
    row31_1: "ECM",
    row31_2: "Abreviatura de Energy Conservation Measure; se refiere a una medida propuesta de mejora de la eficiencia.",
    row32_1: "ECM Report",
    row32_2: "Energy Conservation Measure Report; documento de propuesta que contiene la solución recomendada, el ahorro energético, el análisis financiero y la justificación económica.",
    row33_1: "EER",
    row33_2: "Abreviatura de Energy Efficiency Ratio; significa índice de eficiencia energética.",
    row34_1: "EMEA",
    row34_2: "Europa, Oriente Medio y África. Cartera de fabricación utilizada para enfriadoras Carrier lanzadas en Europa, Oriente Medio y África.",
    row35_1: "Tasa de escalado",
    row35_2: "Incremento porcentual anual supuesto de los costes de explotación, como energía, mantenimiento, reparaciones y otros; el valor predeterminado en iECM es 2 % al año.",
    row36_1: "e-CAT estimado",
    row36_2: "Datos de rendimiento estimados por el algoritmo Digital e-CAT cuando los datos e-CAT estándar no están disponibles.",
    row37_1: "FX rate",
    row37_2: "Abreviatura de Foreign exchange rate; significa tipo de cambio.",
    row38_1: "Hz",
    row38_2: "Hercio, unidad de frecuencia; se utiliza en iECM para definir los límites de funcionamiento de los VFD de bombas y ventiladores de torre de refrigeración.",
    row39_1: "iECM",
    row39_2: "Abreviatura de Intelligent Energy Conservation Measure; herramienta de Carrier para auditoría energética y análisis de retrofit orientada a la optimización de plantas de agua helada.",
    row40_1: "Incentivos y subvenciones",
    row40_2: "Incentivos financieros gubernamentales o de empresas suministradoras incorporados en el cálculo del NPV año a año durante un máximo de 19 años.",
    row41_1: "kgCO₂e",
    row41_2: "Kilogramos de dióxido de carbono equivalente; unidad utilizada para expresar las emisiones de gases de efecto invernadero asociadas al consumo de electricidad.",
    row42_1: "kW",
    row42_2: "Kilovatio, unidad de potencia eléctrica equivalente a 1.000 vatios.",
    row43_1: "kWc",
    row43_2: "Kilovatio de refrigeración; potencia frigorífica suministrada por una enfriadora o una planta, expresada en kilovatios.",
    row44_1: "kWe",
    row44_2: "Input kilowatt electrical; potencia eléctrica consumida por una enfriadora o un componente de la planta.",
    row45_1: "kWh",
    row45_2: "Kilovatio-hora, unidad de energía equivalente a 1 kW mantenido durante 1 hora.",
    row46_1: "kWh/RTh",
    row46_2: "Kilovatios-hora por tonelada de refrigeración-hora; indicador de eficiencia de la planta.",
    row47_1: "Región/fuente de fabricación",
    row47_2:
      "Cartera regional de fabricación de Carrier utilizada para determinar la biblioteca de modelos de enfriadoras compatible (ASIA, EMEA o NAO). La misma familia de enfriadoras puede estar disponible en más de una región.",
    row48_1: "Entrada multipunto",
    row48_2:
      "Función de entrada de datos de iECM que copia el valor del mes actual a todos los meses posteriores, acelerando la entrada repetitiva de datos sin sobrescribir los valores introducidos previamente.",
    row49_1: "NAO",
    row49_2: "North America Operations. Cartera de fabricación utilizada para enfriadoras Carrier lanzadas a través de North America Operations.",
    row50_1: "NPV",
    row50_2: "Abreviatura de Net Present Value; se refiere al valor actual neto de los flujos de caja futuros del proyecto.",
    row51_1: "Valle",
    row51_2: "Temperatura media mensual general. Representa la parte promedio del día y se utiliza para ponderar la asignación del periodo nocturno valle.",
    row52_1: "Periodo operativo",
    row52_2: "Clasificación del tipo de día utilizada en el modelado mensual de la línea base —día laborable, fin de semana o periodo completo— para reflejar diferentes patrones de uso.",
    row53_1: "Enfriadora del sitio en funcionamiento",
    row53_2:
      "Enfriadora del sitio seleccionada para representar la enfriadora principal que funciona durante un periodo de carga específico (como peak u off-peak). La enfriadora seleccionada se utiliza como equipo de referencia para el modelado del rendimiento de baseline y la selección de la enfriadora proxy.",
    row54_1: "Biblioteca personalizada",
    row54_2: "Biblioteca personal que contiene datos de enfriadoras cargados o gestionados por el usuario.",
    row55_1: "Carga parcial",
    row55_2: "Funcionamiento por debajo de la capacidad nominal total.",
    row56_1: "Periodo de retorno",
    row56_2: "Número de años necesarios para que los ahorros anuales acumulados igualen la inversión total inicial en CAPEX.",
    row57_1: "Punta",
    row57_2: "Promedio de las temperaturas máximas diarias del mes. Representa la parte más calurosa del día y se utiliza para ponderar la asignación del periodo diurno peak.",
    row58_1: "Punta / Valle en la tarifa",
    row58_2: "Periodos tarifarios de electricidad por uso horario en los que las horas punta tienen tarifas más altas y las horas valle tienen tarifas más bajas.",
    row59_1: "Sistema de control de planta",
    row59_2:
      "Infraestructura de automatización y control, incluidos sensores, controladores e integración BMS, utilizada para optimizar el funcionamiento de la planta de agua helada propuesta; se incluye como partida de CAPEX.",
    row60_1: "PLR",
    row60_2: "Abreviatura de Part load ratio; significa relación de carga parcial.",
    row61_1: "Sistema primario",
    row61_2: "Configuración de tuberías de agua helada en la que un único conjunto de bombas hace circular el agua tanto por las enfriadoras como por el circuito de distribución del edificio.",
    row62_1: "Sistema primario-secundario",
    row62_2:
      "Configuración de tuberías de agua helada con conjuntos de bombas separados: las bombas primarias atienden a las enfriadoras, mientras que las secundarias atienden al circuito de distribución del edificio, lo que permite un control independiente del caudal.",
    row63_1: "Refrigeración de proceso",
    row63_2: "Refrigeración proporcionada para procesos industriales o de fabricación, como centros de datos o producción farmacéutica; requiere el método de baseline Energy Consumption en iECM.",
    row64_1: "Propuesta",
    row64_2: "La nueva solución recomendada que se evalúa frente a la baseline.",
    row65_1: "Enfriadora proxy",
    row65_2: "Modelo de enfriadora Carrier seleccionado de la biblioteca e-CAT para representar la Operating Site Chiller durante la estimación y calibración del rendimiento.",
    row66_1: "Reconfigurar",
    row66_2:
      "Función de iECM que permite a los usuarios anular manualmente el algoritmo automático de selección de enfriadoras y asignar enfriadoras específicas a periodos operativos concretos dentro de una solución de retrofit.",
    row67_1: "Enfriadora de referencia",
    row67_2:
      "La enfriadora seleccionada como referencia de rendimiento para un patrón de baseline determinado; todos los cálculos de potencia, carga de refrigeración y degradación de esa baseline se derivan de sus especificaciones.",
    row68_1: "Retrofit",
    row68_2: "Proceso de modernizar o sustituir equipos existentes de una planta de agua helada por tecnologías más nuevas y eficientes para reducir el consumo de energía y los costes operativos.",
    row69_1: "ROI",
    row69_2: "Abreviatura de Return on investment; se refiere al ahorro anual expresado como porcentaje de la inversión total.",
    row70_1: "RT",
    row70_2: "Abreviatura de Refrigeration ton; unidad de capacidad frigorífica.",
    row71_1: "RTh",
    row71_2: "Abreviatura de Refrigeration ton-hour; unidad de energía frigorífica.",
    row72_1: "Tarifa eléctrica",
    row72_2: "Precio de la electricidad por kWh cobrado por la empresa de servicios públicos; se introduce por separado para los periodos peak y off-peak en la configuración de baseline.",
    row73_1: "VFD",
    row73_2: "Abreviatura de Variable Frequency Drive; dispositivo que ajusta la velocidad del motor en función de la carga.",
    row74_1: "Enfriadora refrigerada por agua",
    row74_2:
      "Enfriadora que rechaza el calor a través de un circuito de agua de condensación conectado a torres de refrigeración y que normalmente es más eficiente que una enfriadora refrigerada por aire a plena carga.",
    row75_1: "WC",
    row75_2: "Abreviatura de Water-cooled; significa refrigerado por agua."
  }
}



// WEBPACK FOOTER //
// ./src/locale/outputFile/es.js